import { render, staticRenderFns } from "./WayBillInfo.vue?vue&type=template&id=f4ae05b6&scoped=true"
import script from "./WayBillInfo.vue?vue&type=script&lang=ts"
export * from "./WayBillInfo.vue?vue&type=script&lang=ts"
import style0 from "./WayBillInfo.vue?vue&type=style&index=0&id=f4ae05b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ae05b6",
  null
  
)

export default component.exports